{
	"gdprInfo1": "Leyfi til markaðssetningar",
	"gdprInfo2": "Með því að skrá þig á póstlista Póstsins samþykkir þú að þær upplýsingar sem þú veitir verði nýttar til að senda þér og birta sérsniðnar auglýsingar, tilboð og annað markaðsefni á grundvelli veittra upplýsinga.",
	"gdprInfo3": "Hægt er að uppfæra þessar upplýsingar eða afskrá sig af póstlistanum hvenær sem er. Þú getur bæði smellt á viðeigendi hlekk sem er staðsettur neðst í hverjum pósti eða með því að senda okkur skilaboð á postur@postur.is. Persónuverndarstefnu má finna ",
	"gdprInfo3Link": "hér.",
	"gdpr": "Ég samþykki skilmálana og persónuverndarstefnu Póstsins."
}
